/* recently-viewed.js — remember viewed products, then re-render them through
   the Recently viewed section via the Search API so the markup stays
   server-rendered (live price, stock, badges). */
(function () {
  'use strict';

  const KEY = 'trademart:recently-viewed';
  const MAX = 20;

  function read() {
    try {
      const raw = localStorage.getItem(KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter((n) => typeof n === 'number') : [];
    } catch (e) {
      return []; // private mode / disabled storage — degrade to nothing
    }
  }

  function remember(id) {
    if (!id) return;
    try {
      const list = read().filter((x) => x !== id);
      list.unshift(id);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* storage unavailable — the section simply stays hidden */
    }
  }

  async function render(host) {
    const currentId = parseInt(host.getAttribute('data-current-id') || '0', 10);
    const limit = parseInt(host.getAttribute('data-limit') || '5', 10);
    const ids = read().filter((id) => id !== currentId).slice(0, limit);
    if (!ids.length) return;

    const q = ids.map((id) => 'id:' + id).join(' OR ');
    const url =
      '/search?section_id=' + encodeURIComponent(host.getAttribute('data-section-id')) +
      '&type=product&options[unavailable_products]=last&q=' + encodeURIComponent(q);

    try {
      const res = await fetch(url);
      if (!res.ok) return;
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = doc.querySelector('[data-recently-viewed]');
      if (!fresh || !fresh.querySelector('.product-card')) return;

      host.innerHTML = fresh.innerHTML;
      host.hidden = false;

      /* hand the new cards to the shared scroll-reveal so they fade in like
         every other product grid instead of appearing abruptly */
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        host.querySelectorAll('.product-card').forEach((card, i) => {
          card.classList.add('reveal');
          requestAnimationFrame(() => {
            card.style.transitionDelay = Math.min(i, 6) * 55 + 'ms';
            card.classList.add('is-visible');
          });
        });
      }
    } catch (e) {
      /* network failure — leave the section hidden rather than showing an
         empty heading */
    }
  }

  function init() {
    const host = document.querySelector('[data-recently-viewed]');
    if (host) render(host);

    /* record AFTER rendering, so the current product doesn't appear in its own list */
    const root = document.querySelector('[data-product-root]');
    if (root) {
      const idEl = document.querySelector('[data-variant-id]');
      const pid = host && host.getAttribute('data-current-id');
      if (pid) remember(parseInt(pid, 10));
      else if (idEl) remember(parseInt(idEl.value, 10));
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
